import ExperienceDetailsList from './experience-details-list';

export default ExperienceDetailsList;
